export enum TableKeyEnum {
  PRODUCTIONBATCH_INPUT = 'productionbatch_input',
  PRODUCTIONBATCH_OUTPUT = 'productionbatch_output',
  PRODUCTIONBATCH_COSTHEAD = 'productionbatch_costhead',
  PURCHASE_ORDER_LIST = 'purchase_order_list',
  ROLL_REPORT_TABLE = 'roll_report',
  STORE_MANAGEMENT = 'store_management',
  RECONCILIATION = 'reconciliation',
  MATRIALRECONCILIATION = 'materialreconciliation',
  STOCK_TRANSFER = 'stock_transfer',
  APPROVAL_GENERIC_PO = 'generic_approval_po_list',
  APPROVAL_GENERIC_SO = 'generic_approval_so_list',
  APPROVAL_GENERIC_INWARD_LIST = 'generic_approval_inward_list',
  BOM_LIST = 'bom_list',
  JOB_WORK_LIST = 'job_work_list',
  BRANCH = 'branch_list',
  CATEGORY_TYPLE = 'category_typle_list',
  COST_HEAD = 'cost_head_list',
  CRM_ACTIVITY = 'crm_activity_list',
  CUSTOM_FIELD = 'custom_field_list',
  CUSTOM_MODULE_FIELD = 'custom_module_field_list',
  CUSTOM_PARAMETERS = 'custom_parameters_list',
  DEPARTMENT = 'department',
  DIGITALPLATFORM = 'digitalplatform_list',
  DISPATCH = 'dispatch_list',
  FUNNEL_SOURCE = 'funnel-source_list',
  FUNNEL_STAGE = 'funnel_stage_list',
  INWARD = 'inward_list',
  LAB_TEST = 'lab_test_list',
  LOCATION = 'location_list',
  LOT_WISE_PRODUCTION_BATCH = 'lot_wise_production_batch_list',
  MACHINE = 'machine_list',
  MACHINE_ACTIVITIES_LIST = 'machine_activities_list',
  MACHINE_ASSETS_ACTIVITY = 'machine_assets_activity_list',
  MACHINE_ASSETS = 'machine_assets_list',
  MACHINE_SETTING = 'machine_setting_list',
  MATERIAL_PROPERTIES = 'material_properties_list',
  MATERIAL_REQUEST = 'material_request_list',
  MOISTURE_LIST = 'moisture_list',
  MOULD = 'mould_list',
  MOULD_NAME = 'mouldname_list',
  MOULD_TYPE = 'mouldType_list',
  NEW_PRODUCTION_BATCH = 'new_production_batch_list',
  PACKAGING = 'packaging_list',
  PACKING = 'packing_list',
  PARTY = 'party_list',
  PARTY_TYPE = 'party_type_list',
  PH_LIST = 'phlist',
  PROCESS = 'process_list',
  PROCESS_TYPE_LIST = 'process_type_list',
  PRODUCT = 'product_list',
  PRODUCT_CODES = 'product_codes_list',
  PRODUCT_TYPE = 'product_type_list',
  PRODUCTION_BATCH = 'production_batch_list',
  PURCHASE_ORDER = 'purchase_order_list',
  PURITY_LIST = 'purity_list',
  QUOTATION = 'quotation_list',
  RACK_LIST = 'rack_list',
  SALES_ORDER = 'sales_order_list',
  SLITTING_PROCESS_LIST = 'slitting_process_list',
  SOLUBILITY = 'solubility_list',
  STOCK_AREA = 'stock_area_list',
  STOCK_MANAGEMENT_LIST = 'store-management_list',
  SUPPORTING_MATERIAL = 'supporting_material_list',
  TRANSFER_APPROVAL = 'transfer_approval_list',
  UOM = 'uom_list',
  WEAVING_PROCESS = 'weaving_process_list',
  FREIGHT = 'Freight',
  BAGMAKING_PROCESS = 'Bag_making_list',
  VENDOR_LIST = 'vendor list',
  USER_LIST = 'user_list',
  MESSAGE_TEMPLATE = 'message_template',
  APPROVAL_CONFIG = 'approval_config',
  MESSAGE_PARAM_CONFIG = 'message_param_config',
  PRINT_TEMPLATE = 'print_template',
  SYSTEM_CONFIG_SETTING = 'system_config_setting',
  ACL_LIST = 'acl_list',
  INVOICE_LIST = 'invoices_list',
  VENDOR='vendor',
  PRICE_MATRICS = 'price_matrics',
  TAX = 'tax_list',
  MODIFICATION_APPROVAL = 'modification_approval_list',
  MODIFICATION_REQUEST = 'modification_request_list',
  CREDIT_NOTE_LIST = 'credit_note_list',
  CRITERIA_QUESTION = 'criteria_question',
  COLLECTION_REPORT = 'collection_report',
  FUNNEL_LIST='funnel-list',
  VEHICLE='vehicle_list',
  DRIVER='driver_list',
}
